


import {catchError} from 'rxjs/operators';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { blockUi } from "@bndes/bndes-ux4/bndes-angular-utils";

import { LimiteContratacao, LimiteAgenteFinanceiro, LimitesFundo, LimiteFundoCadastro } from 'src/app/model/limite-agente-financeiro.model';
import { AgenteFinanceiro } from '../../model/agente-financeiro.model';
import { FgiBackEndService } from '../fgi-back-end.service';
import moment from "moment";
import { ResultadoPaginado } from 'src/app/model/resultado';

@Injectable({
  providedIn: 'root'
})
export class LimiteService extends FgiBackEndService<LimiteAgenteFinanceiro>{
  // @Override
  getNewEntity() {
  const agente: AgenteFinanceiro = new AgenteFinanceiro();
  agente.id = null;
  agente.cnpj = '';
  agente.nome = '';
  const limite = new LimiteContratacao(0, 0, 0);

    return new LimiteAgenteFinanceiro(agente, limite);
  }

  // @Override
  protected getResourceURL(): string {
    return 'front/limite/agentes';
  }

  public getLimitesFundo(): Observable<LimitesFundo> {
    return this.http.get(`rest/front/limite/limites`).pipe(
      catchError((e) => this.handleError(e))) as Observable<LimitesFundo>;
  }

  public getLimitesFundoTranchesPassadas(): Observable<Array<LimitesFundo>> {
    
    return this.http.get(`rest/front/limite/limites/tranches-passadas`).pipe(
      catchError((e) => this.handleError(e))) as Observable<Array<LimitesFundo>>;
  }

  public salvarOuAtualizarLimiteFundo(limiteFundoCadastro: LimiteFundoCadastro): Observable<any> {
    const options: any = blockUi();
    return this.http.post(`rest/front/limite/limite-fundo`, limiteFundoCadastro, options).pipe(
        catchError((e) => this.handleError(e))) as Observable<any>;
  }

  // public getHistoricoLimiteFundoTrancheAtual(apenasAlteracoesManuais: boolean): Observable<any> {
  //   const params: any = {}
  //   params.apenasAlteracoesManuais = apenasAlteracoesManuais;
  //   return this.http.get(`rest/front/limite/limite-fundo/historico`, { params: params }).pipe(
  //       catchError((e) => this.handleError(e))) as Observable<any>;
  // }
  public getHistoricoLimiteFundoTrancheAtual(params?: any): Observable<ResultadoPaginado<any>> {
    return this.http.get(`rest/front/limite/limite-fundo/historico`, { params: params }).pipe(
        catchError((e) => this.handleError(e))) as Observable<any>;
  }

  public getLimiteFundo(dataReferencia: Date): Observable<LimiteFundoCadastro> {
    const params: any = {}
    params.dataReferencia = moment(dataReferencia).format('YYYYMMDD');

   return this.http.get(`rest/front/limite/limite-fundo`, { params: params }).pipe(
          catchError((e) => this.handleError(e))) as Observable<LimiteFundoCadastro>;
  }

  public getDataLimiteFundo(dataReferencia: Date): Observable<Date> {
    const params: any = {}
    params.dataReferencia = moment(dataReferencia).format('YYYYMMDD');

   return this.http.get(`rest/front/limite/data-limite-fundo`, { params: params }).pipe(
          catchError((e) => this.handleError(e))) as Observable<Date>;
  }

  public getLimiteComHistoricoCarregado(ideLimiteAgenteTranche: number): Observable<LimiteAgenteFinanceiro> {
    const options: any = blockUi();
    options.params.carregarHistorico = true;

    return this.http.get(`${this.BASE_URL}/${ideLimiteAgenteTranche}`, options).pipe(
      catchError((e) => this.handleError(e))) as Observable<LimiteAgenteFinanceiro>;
  }
}
